import { Instance, types } from "mobx-state-tree";

import { endpoints } from "../api/ApiEndpoints";
import { StorageModel } from "../storage/StorageModel";

export const InspectionReportModel = types.model({
  currentInspectionId: types.optional(types.frozen<number>(), 0),
  report: types.optional(types.frozen<string>(), ""),
});

export const InspectionReportStorageModel = types
  .compose(InspectionReportModel, StorageModel)
  .named("InspectionStorageReportModel")
  .actions((self) => {
    return {
      mapResponse(response: any) {
        self.report = response.data;
      },
      downloadReport(reportName: string) {
        if (!self.report) return;

        var blob = new Blob([self.report], { type: "application/pdf" });
        var reportUrl = window.URL.createObjectURL(blob);

        var downloadElement = document.createElement("a");
        downloadElement.href = reportUrl;
        downloadElement.download = `${reportName}.pdf`;

        document.body.appendChild(downloadElement);

        downloadElement.click();
        document.body.removeChild(downloadElement);
        window.URL.revokeObjectURL(reportUrl);
      },
    };
  })
  .views((self) => ({
    get endpoint() {
      const endpoint = endpoints.get("inspection_report");
      endpoint.routeParams = [self.currentInspectionId];
      return endpoint;
    },
    get isLoading() {
      return self.currentInspectionId <= 0;
    },
    get reportUrl() {
      if (self.report) {
        const blob = new Blob([self.report], { type: "application/pdf" });
        return URL.createObjectURL(blob);
      }
      return "";
    },
  }));

export type InspectionReportStorage = Instance<typeof InspectionReportStorageModel>;
